import { Box, Icon, Tooltip, Typography } from '@mui/material';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useNavigation } from '@/providers/navigation-provider';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';
import * as colors from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function MainNavTrialCta({ subscriptionExpireDate }: { subscriptionExpireDate: string }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const { mainNavOpen } = useNavigation();

    const daysRemaining = subscriptionExpireDate ? dayjs(subscriptionExpireDate).diff(dayjs(), 'days') : 1;

    return (
        <Link to="/settings/workspace/billing#upgrade" style={{ textDecoration: 'none' }}>
            {mainNavOpen ? (
                <Box
                    sx={{
                        px: 2,
                        py: 1,
                    }}
                    data-id="menu-trial-cta"
                >
                    <Typography color={colors.yellow[700]} noWrap>
                        {t('str.cta.trial.start-sub')}
                    </Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary} noWrap>
                        {daysRemaining > 0
                            ? t('str.cta.trial.days-trial', {
                                  count: daysRemaining,
                                  days: daysRemaining,
                              })
                            : t('billing.subscription.overview.time.card.subtitle.trial-ended')}
                    </Typography>
                </Box>
            ) : (
                <Tooltip
                    title={
                        daysRemaining > 0
                            ? t('str.cta.trial.days-trial', {
                                  count: daysRemaining,
                                  days: daysRemaining,
                              })
                            : t('billing.subscription.overview.time.card.subtitle.trial-ended')
                    }
                    arrow
                    placement="right"
                    data-id="menu-trial-cta"
                >
                    <Icon sx={{ display: 'flex', margin: '1.5rem auto' }}>
                        <NewReleasesIcon sx={{ color: colors.yellow[700] }} />
                    </Icon>
                </Tooltip>
            )}
        </Link>
    );
}
